<section fxLayoutAlign="end center">
  <sbnb-close [border]="true" (click)="dialogRef.close()"></sbnb-close>
</section>

<section fxFlexFill fxLayout fxLayoutAlign="center center">
  <ng-template *ngIf="selectedStage === 'selectParent'" [ngTemplateOutlet]="selectParentTemplate"></ng-template>
  <ng-template
    *ngIf="selectedStage === 'selectInteraction'"
    [ngTemplateOutlet]="selectInteractionTemplate"></ng-template>
  <ng-template *ngIf="selectedStage === 'reviewConfirmation'" [ngTemplateOutlet]="reviewTemplate"></ng-template>
  <ng-template *ngIf="selectedStage === 'success'" [ngTemplateOutlet]="successTemplate"></ng-template>
</section>

<ng-template #header>
  <h2 fxLayoutGap="12px" fxLayoutAlign="start center">
    <img src="/assets/iconography/parent-child-icon.png" />
    <span>Parent-child</span>
  </h2>
</ng-template>

<ng-template #selectParentTemplate>
  <div class="fs-dialog-contents">
    <ng-template [ngTemplateOutlet]="header"></ng-template>
    <p>
      You're configuring a parent-child relationship between the following properties. When the parent is booked, the
      related children property calendars will be blocked.
    </p>

    <p style="margin-top: 30px"><strong>Which property is the parent property?</strong></p>

    <mat-radio-group [(ngModel)]="selectedParent" fxLayout="column" fxLayoutGap="12px">
      <mat-radio-button *ngFor="let property of dialogData.properties" [value]="property.id" fxFlex>
        <div fxLayout fxLayoutGap="12px" style="margin-left: 6px">
          <img src="{{ property.picture }}" class="property-thumb" />
          <div fxLayout="column" fxLayoutGap="0px">
            <div>{{ property.name }}</div>
            <div *ngIf="property.tags" class="raspberry-darker text__small">{{ property.tags }}</div>
          </div>
        </div>
      </mat-radio-button>
    </mat-radio-group>

    <div fxLayoutAlign="end center" style="margin-top: 20px">
      <sbnb-button [disabled]="!selectedParent" (click)="progressStage()">Continue</sbnb-button>
    </div>
  </div>
</ng-template>

<ng-template #selectInteractionTemplate>
  <div class="fs-dialog-contents">
    <ng-template [ngTemplateOutlet]="header"></ng-template>
    <p><strong>How should the child properties interact?</strong></p>

    <mat-radio-group [(ngModel)]="interactionType" fxLayout="column" fxLayoutGap="12px">
      <mat-radio-button fxFlex [value]="'none-blocking'">
        <div fxLayout fxLayoutGap="12px" style="margin-left: 6px">
          <div fxLayout="column" fxLayoutGap="6px">
            <strong>
              These child properties
              <em>can</em>
              be booked at the same time.
            </strong>
            <div style="line-height: 1.6">
              A booking on a child property's calendar will block the parent property's calendar.
            </div>
          </div>
        </div>
      </mat-radio-button>

      <mat-radio-button fxFlex [value]="'blocking'">
        <div fxLayout fxLayoutGap="12px" style="margin-left: 6px">
          <div fxLayout="column" fxLayoutGap="6px">
            <strong>
              These child properties
              <em>can not</em>
              be booked at the same time.
            </strong>
            <div style="line-height: 1.6">
              A booking on a child property's calendar will block the parent property's calendar, and all child
              property's calendars.
            </div>
          </div>
        </div>
      </mat-radio-button>
    </mat-radio-group>

    <div fxLayoutAlign="end center" fxLayoutGap="12px" style="margin-top: 20px">
      <sbnb-button type="secondary" (clicked)="goBack()">Go back</sbnb-button>
      <sbnb-button [disabled]="!interactionType" (clicked)="progressStage()">Continue</sbnb-button>
    </div>
  </div>
</ng-template>

<ng-template #reviewTemplate>
  <div class="fs-dialog-contents-wide">
    <ng-template [ngTemplateOutlet]="header"></ng-template>
    <p>Confirm the relationship and the behavior or go back to make changes.</p>
    <p>Sync will be enabled for these properties upon confirmation.</p>

    <div class="review-headings" fxLayout fxLayoutGap="24px">
      <div fxFlex>Property name</div>
      <div fxFlex="80px">Relationship</div>
      <div fxFlex>Behavior</div>
    </div>

    <div
      *ngFor="
        let property of dialogData.properties | parentChildSetupSortPropertiesParentFirst: selectedParent;
        let i = index;
        let last = last
      "
      class="review-property"
      [class.parent]="i === 0"
      [class.last]="last"
      fxLayout
      fxLayoutAlign="start center"
      fxLayoutGap="24px">
      <div fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
        <img *ngIf="i === 0" fxHide.lt-md [src]="property.picture" class="property-thumb" />

        <div *ngIf="i !== 0" fxHide.lt-md class="child-arrow">
          <div class="child-arrow-vertical"></div>
          <div class="child-arrow-horizontal"></div>
          <div class="child-arrow-head"></div>
        </div>

        <div>{{ property.name }}</div>
      </div>

      <div fxFlex="80px" class="badge" [class.badge-parent]="i === 0">{{ i === 0 ? 'Parent' : 'Child' }}</div>
      <div fxFlex class="text__small">
        <span *ngIf="i === 0">A booking at this property will block all children property calendars.</span>
        <span *ngIf="i !== 0 && interactionType === 'none-blocking'">
          A booking at this property will block the parent property's calendar.
        </span>
        <span *ngIf="i !== 0 && interactionType === 'blocking'">
          A booking at this property will block the parent property's calendar, and all child property's calendars.
        </span>
      </div>
    </div>

    <div fxLayoutAlign="end center" fxLayoutGap="12px" style="margin-top: 40px">
      <sbnb-button type="secondary" (clicked)="goBack()">Go back</sbnb-button>
      <sbnb-button (clicked)="saveRelationship()" [loading]="saving">Confirm</sbnb-button>
    </div>
  </div>
</ng-template>

<ng-template #successTemplate>
  <div class="fs-dialog-contents-wide" fxLayout fxLayoutGap="40px">
    <div fxFlex>
      <ng-template [ngTemplateOutlet]="header"></ng-template>
      <p>
        <strong>Congratulations!</strong>
        You've configured a parent-child relationship between these properties. You'll now see them grouped together
        throughout Hospitable, and we'll make sure the Hospitable calendars are blocked accordingly and pushed out to
        all connected channels.
      </p>

      <div *ngIf="updatedSecondaryUsers?.length > 0" style="margin-top: 40px">
        <strong>Secondary user permissions have been updated.</strong>
        <p>
          We've updated permissions for these secondary users, to now have access to all properties in this parent-child
          relationship.
        </p>

        <ul>
          <li *ngFor="let user of updatedSecondaryUsers">{{ user.name }}</li>
        </ul>
      </div>

      <div style="margin-top: 40px">
        <sbnb-button (clicked)="redirectToCalendar()">View calendar</sbnb-button>
      </div>
    </div>

    <img fxHide.lt-md src="/assets/images/jake-juggling.svg" />
  </div>
</ng-template>
